import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

const Index = ({
  value,
  handleChange,
  dropdownId,
  placeholder,
  selectedId,
  description,
  selectAllText,
  coteacherText,
  showValidation
}) => {
  const [visible, setVisible] = useState(false);
  const [results, setResults] = useState(value);
  const [isSearch, setIsSearch] = useState(false);

  const truncateText = (text, maxLength = 30) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };
  let display = '';
  switch (description) {
  case true:
    display = 'd-block';
    break;
  case false:
    display = 'd-none';
    break;
  default:
    display = 'd-none';
    break;
  }

  useEffect(() => {
    let classList = [...value];
    let newResults = [];
    results.forEach((resultItem) => {
      const matchArray = classList.filter((classItem) => resultItem.id === classItem.id);
      if (matchArray !== undefined && matchArray.length > 0) {
        newResults.push({ ...resultItem, isChecked: matchArray[0].isChecked });
      }
    });
    setResults(newResults);
  }, [value]);

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  // const closeChip = (event, id) => {
  //   event.stopPropagation();
  //   const dataValue = value.map((item) => (item.id === id ? { ...item, isChecked: false } : item));
  //   const dataSelectedId = selectedId.filter((item) => item !== id);
  //   setValue(dataValue);
  //   if (dataSelectedId.length === 0) setSelectedId([]);
  //   else setSelectedId(dataSelectedId);
  // };

  const searchHandler = (e) => {
    const searchString = e.target.value;
    const searchResults = value.filter((item) =>
      item.name.toLowerCase().includes(searchString.toLowerCase())
    );
    setIsSearch(true);
    setResults(searchResults);
  };

  const menu = (
    <Menu style={{ width: '100%' }} multiple onSelect={handleChange} onDeselect={handleChange}>
      <div className="custom-search position-relative mb-3">
        <FontAwesomeIcon icon={faSearch} />
        <input type="text" onChange={(e) => searchHandler(e)} className="form-control" />
      </div>
      
      {selectAllText &&<MenuItem key="000">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            checked={value.filter((item) => item?.isChecked !== true).length < 1}
            onChange={() => { }}
            name={`check-all-${selectAllText}`}
            id={`check-all-${selectAllText}`}
          />
          <div htmlFor={`check-all-${selectAllText}`}>{selectAllText}</div>
        </div>
      </MenuItem> }

      {isSearch ? (
        <>
          {results.length > 0 && results.map((item, index) => (
            <MenuItem key={item.id}>
              <div className="form-check">
                <input
                  key={`name${item.id}`}
                  type="checkbox"
                  className="form-check-input"
                  checked={item.isChecked}
                  onChange={() => { }}
                  name={'check-' + index}
                  id={'check-' + index + item.id}
                />
                <div className="mb-0" title={item.name}>
                  <div htmlFor={'check-' + index}>
                    {truncateText(item.name, 30)}{' '}
                    <>
                      {coteacherText ? (
                        <span className="text-danger">
                          {item.description?.length > 0 ? item.description : ''}
                        </span>
                      ) : (
                        ''
                      )}
                    </>
                  </div>
                  {!coteacherText ? (
                    <>
                      <small className={display}>{item.description}</small>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </MenuItem>
          ))}

          {results.length <= 0 &&
          <div className="rc-menu-item cursor-pointer">
            <div className="text-danger">
              No results found
            </div>
          </div>}
        </>
      ) : (
        <>
          {value.map((item, index) => (
            <MenuItem key={item.id}>
              <div className="form-check">
                <input
                  key={`name${item.id}`}
                  type="checkbox"
                  className="form-check-input"
                  checked={item.isChecked}
                  onChange={() => { }}
                  name={'check-' + index}
                  id={'check-' + index + item.id}
                />
                <div className="mb-0" title={item.name}>
                  <div htmlFor={'check-' + index}>
                    {truncateText(item.name, 30)}{' '}
                    <>
                      {coteacherText ? (
                        <span className="text-danger">
                          {item.description?.length > 0 ? item.description : ''}
                        </span>
                      ) : (
                        ''
                      )}
                    </>
                  </div>
                  {!coteacherText ? (
                    <>
                      <small className={display}>{item.description}</small>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </MenuItem>
          ))}
        </>
      )}
    </Menu>
  );

  return (
    <div id={dropdownId}  className={showValidation && 'border-red rounded'}>
      <Dropdown
        trigger={['click']}
        onVisibleChange={handleVisibleChange}
        visible={visible}
        closeOnSelect={false}
        overlay={menu}
        animation="slide-up"
        getPopupContainer={() => document.getElementById(dropdownId)}>
        <div className="form-select form-chips d-flex align-items-center gap-2 flex-wrap overflow-auto">
          {(selectedId === null || selectedId?.length === 0) && (
            <div className="form-placeholder">{placeholder}</div>
          )}
          {selectedId?.length === value.length && value.length > 0 && (
            <div className="form-placeholder">{selectAllText}</div>
          )}
          {selectedId?.length > 0 &&
            selectedId?.length != value.length &&
            value
              .filter((item) => selectedId.includes(item?.id))
              .map((itemName) => (
                <span key={`span${itemName?.id}`} className='d-flex flex-row' title={itemName?.name}>
                  {truncateText(itemName?.name, 30)}
                  <Menu style={{marginBottom: '0px', marginLeft: '0px', paddingLeft: '.75em'}} onClick={(e) => e.domEvent.stopPropagation()} onSelect={handleChange}>
                    <MenuItem key={itemName?.id}>
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        id={`chip-${itemName?.name}-${itemName?.id}`}
                      />
                    </MenuItem>
                  </Menu>

                </span>
              ))}
        </div>
      </Dropdown>
    </div>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  handleChange: PropTypes.func,
  dropdownId: PropTypes.string,
  placeholder: PropTypes.string,
  selectedId: PropTypes.array,
  description: PropTypes.bool,
  selectAllText: PropTypes.string,
  coteacherText: PropTypes.bool,
  showValidation: PropTypes.bool
};

export default Index;
